import store from '../../../configureStore';

const R = require('ramda');
import { DOCUMENT_TYPES } from '../../../config/constants';
import api from '@synergycms_core/utils/api';
import {FIDELTOUR_CODE} from '@synergycms_app/store/customer/loyaltyActions';

export default [
  {
    type: 'required',
    validText: '',
    invalidText: '_%el campo {field} es obligatorio%_',
    method: value => {
      return value || (value && value.length);
    }
  },
  {
    type: 'maxLength',
    validText: '',
    invalidText: '_%el campo {field} no puede tener mas de {maxLength} caracteres%_',
    method: (value, validation) => {
      return value.length <= validation.maxLength;
    }
  },
  {
    type: 'minLength',
    validText: '',
    invalidText: '_%el campo {field} no puede tener menos de {minLength} caracteres%_',
    method: (value, validation) => {
      return value.length >= validation.minLength;
    }
  },
  {
    type: 'email',
    validText: '',
    invalidText: '_%el formato tiene que ser de email%_',
    method: (value, validation) => {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return value && re.test(String(value).toLowerCase());
    }
  },
  {
    type: 'number',
    validText: '',
    invalidText: '_%el campo {field} tiene que ser un número%_',
    method: (value, validation) => {
      const reg = /^\d+$/;
      return reg.test(String(value).toLowerCase());
    }
  },
  {
    type: 'phone',
    validText: '',
    invalidText: '_%el campo {field} tiene que ser un número de teléfono válido%_',
    method: (value, validation) => {
      const reg = /^\d+$/;
      return reg.test(R.replace(/[  *]/g, '', value));
    }
  },
  {
    type: 'compareField',
    validText: '',
    invalidText: '_%el campo {field} tiene que ser igual al campo {alterField}%_',
    method: (value, validation, input, inputs) => {
      const alterModel = inputs[validation.alterModel];
      if (value === null || alterModel.value === null) {
        return { valid: true };
      }
      if (alterModel && alterModel.value && value && alterModel.value.toLowerCase() === value.toLowerCase()) {
        if (input.validation && input.validation.valid !== true && alterModel.validation.type === 'compareField') {
          return {
            valid: true,
            callback: () => {
              alterModel.onChange(alterModel.value);
            }
          };
        }
        return true;
      } else {
        if (input.validation && input.validation.valid === true) {
          return {
            valid: false,
            callback: () => {
              alterModel.onChange(alterModel.value);
            }
          };
        }
        return false;
      }
    }
  },
  {
    type: 'promoCode',
    validText: '',
    invalidText: '_%el código promocional no es válido%_',
    method: (value, validation, input, inputs) => {
      if (value) {
        return validation.action().then(result => {
          return true;
        });
      }
      return true;
    }
  },
  //currentValidation.method(value, currentValidation, currentModel, this.state.inputList);
  {
    type: 'tax_number',
    validText: '',
    invalidText: '_%el documento introducido no es valido%_',
    method: (value, validation, input, inputs, from) => {

      const { nationality, document_type, tax_number } = inputs;
      
      const model = input.model;
      const taxInput = inputs["tax_number"];
      const nationalityValue = model === "nationality" ? value?.get("alpha2") : nationality.value?.get("alpha2");
      const documentValue =  model === "document_type" ? value?.value : document_type?.value?.value;
      const taxNumberValue = model === "tax_number" ? value : tax_number?.value;

      const currentDocumentTypes = DOCUMENT_TYPES[nationalityValue];

      //Si el pais no esta en la lista de paises que requieren documentos directamente devolvemos valido
      //debugger;
      if(!currentDocumentTypes) {
        return true;
      } else if (nationalityValue && documentValue && taxNumberValue) {

        return api.patch({
          path:"document_validator",
          store: ({store, request}) => {
            const key = `${nationalityValue}-${documentValue}-${taxNumberValue}`;
            store[key] = store[key] ? store[key] : request();
            return  store[key];
          },
          body:  {
            "nationality": nationalityValue,
            "document_type": documentValue,
            "tax_number": taxNumberValue
          }
        }).then((result)=>{
          if (!result.success && model === "tax_number") {
            return false;
          } else if (!result.succes && model !== "tax_number" && taxInput) {
            return {
              valid :true,
              callback : ()=> {
                taxInput.onChange(taxNumberValue);
              }
            };
          } else {
            return true;
          }
        });
        
      } else {
        if(model !== "tax_number" && taxInput) {
          return {
            valid :true,
            callback : ()=> {
              taxInput.onChange(taxNumberValue);
            }
          };
        }
      }
    }
  },
  {
    type: 'loyaltyEmail',
    validText: '',
    invalidText: '_%ya existe un usuario con este correo%_',
    method: (value, validation) => {
      
      const hotelId = store.getState().getIn(["customer", "current_hotel"]);
      const loyaltyRoomsAvail = store.getState().getIn([
        'avail',
        hotelId,
        store.getState().getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']),
        'response'
      ],false);
      const roomRatesSelected = store.getState().getIn(['customer', 'reservation_request']);
      const loyaltySelected = !!loyaltyRoomsAvail && roomRatesSelected.get('loyalty', false);
      const loyaltyType = store.getState().getIn(["customer", "loyalty", "data", "loyalty", "code"], null);
      
      if(!loyaltySelected || loyaltyType !== FIDELTOUR_CODE) return true;

      const loyaltyUser = store.getState().getIn(['customer', 'loyalty','user',"user_id"], null) && store.getState().getIn(['customer', 'loyalty','user'], null);
      if(loyaltyUser != null) return true;

      //const hotelId = store.getState().getIn(["customer", "current_hotel"]);
      const loyalty = store.getState().getIn(["hotels", hotelId, "loyalty"]);

      if(hotelId && loyalty) {

        return api.get(
          'management/loyalty/' + loyalty.get('id') + '/resources/contact',
          {
            mail: value
          },
          hotelId,
          null,
          ({store, request}) => {
            store[value] = store[value] ? store[value] : request();
            return  store[value];
          },
        ).then((response) => {


        // return api.get('management/loyalty/' + loyalty.get('id') + '/resources/contact', { mail: value }, hotelId).then((response) => {

          if (response == null) {
            throw new Error('Error en la petición');
          }

          const { success, ...data } = response;

          return !success;


        });
      }
      else {
        return false;
      }
    }
  },
];

